const React = require('react');
const PropTypes = require('prop-types');

const SentryWrapper = ({ element }) => <SentryBrowser element={element} />;

class SentryBrowser extends React.Component {
  componentDidCatch(error, errorInfo) {
    Sentry.configureScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
    });
    Sentry.captureException(error);
  }

  render() {
    const { element } = this.props;
    return element;
  }
}

SentryWrapper.propTypes = {
  element: PropTypes.element.isRequired,
};

SentryBrowser.propTypes = {
  element: PropTypes.element.isRequired,
};

module.exports = SentryWrapper;
